// src/types.ts
export interface Guest {
  id: string;
  name: string;
}

export interface ReceiptItem {
  id: string;
  name: string;
  price: number;
  assignedGuestIds: string[];
}

export interface Bill {
  restaurantName: string;
  date: Date;
  items: ReceiptItem[];
  guests: Guest[];
  subtotal: number;
  taxInput: number;
  serviceChargeInput: number;
  autoGratuityInput: number;
  additionalGratuityInput: number;
  taxIsPercentage: boolean;
  serviceIsPercentage: boolean;
  autoGratIsPercentage: boolean;
  addGratIsPercentage: boolean;
  notes: string;
}

export enum ScanCategory {
  Item = 'item',
  Tax = 'tax',
  Gratuity = 'gratuity',
  Fee = 'fee'
}

export interface ScannedItem {
  id: string;
  name: string;
  price: number;
  category: ScanCategory;
}

export interface ScanResult {
  items: ScannedItem[];
  lines: string[];
  rawLines: string[];
}
